import { setShowExportHistoryModal } from '../State/showExportHistoryModal';

export default () => async (dispatch) => {

  dispatch(setShowExportHistoryModal(false));
  
}